export const leftPanelSummary = 'Summary';
export const leftPanelClientInsurerId = 'Client Insurer Id';
export const leftPanelClient = 'Client';
export const leftPanelInsurer = 'Insurer';
export const leftPanelPartner = 'Partnership';
export const leftPanelIdentifier = 'Identifier';
export const leftPanelAdminPanelAction = 'Open in admin panel';
export const leftPanelBillsDestination = 'Bills';
export const leftPanelToolDestination = 'Billing tool';
